// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ContactBubble__bubble-c95709 {
  min-width: 280px;
}

.ContactBubble__content-f79ef7 {
  display: flex;
  flex-direction: column;
  position: relative;
}

.ContactBubble__sender-name-bff3c2 {
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 4px;
}

.ContactBubble__quote-db6dba {
  margin-bottom: 9px;
}

.ContactBubble__forward-d7571d {
  margin-bottom: 4px;
}

.ContactBubble__status-bar-default-c6854d {
  position: absolute;
  right: 0;
  bottom: 4px;
}

.ContactBubble__status-bar-after-button-a0f1a9 {
  align-self: flex-end;
}

.ContactBubble__thread-button-e4ca49 {
  margin: 10px -12px -10px -12px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/bubbles/ContactBubble/ContactBubble.styles.m.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,uBAAA;EACA,mBAAA;EAEA,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,8BAAA;AAAF","sourcesContent":[".bubble {\n  min-width: 280px;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\n.sender-name {\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  margin-bottom: 4px;\n}\n\n.quote {\n  margin-bottom: 9px;\n}\n\n.forward {\n  margin-bottom: 4px;\n}\n\n.status-bar-default {\n  position: absolute;\n  right: 0;\n  bottom: 4px;\n}\n\n.status-bar-after-button {\n  align-self: flex-end;\n}\n\n.thread-button {\n  margin: 10px -12px -10px -12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bubble": `ContactBubble__bubble-c95709`,
	"content": `ContactBubble__content-f79ef7`,
	"sender-name": `ContactBubble__sender-name-bff3c2`,
	"senderName": `ContactBubble__sender-name-bff3c2`,
	"quote": `ContactBubble__quote-db6dba`,
	"forward": `ContactBubble__forward-d7571d`,
	"status-bar-default": `ContactBubble__status-bar-default-c6854d`,
	"statusBarDefault": `ContactBubble__status-bar-default-c6854d`,
	"status-bar-after-button": `ContactBubble__status-bar-after-button-a0f1a9`,
	"statusBarAfterButton": `ContactBubble__status-bar-after-button-a0f1a9`,
	"thread-button": `ContactBubble__thread-button-e4ca49`,
	"threadButton": `ContactBubble__thread-button-e4ca49`
};
module.exports = ___CSS_LOADER_EXPORT___;
